import axios from 'axios'
import store from '@/store'
import { getToken, setToken } from '@/utils/auth'

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

http.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      store.dispatch('auth/clearSession', { notifyServer: true })
      const path = window.location.pathname
      if (path !== '/login' && path !== '/register') {
        import('@/router').then(({ default: router }) => {
          if (router.currentRoute.name !== 'Login') {
            router.replace({ name: 'Login', query: { redirect: path } }).catch(() => {})
          }
        })
      }
    }
    return Promise.reject(error)
  }
)

export function bootstrapAuthHeader() {
  const token = getToken()
  if (token) {
    setToken(token)
  }
}

export default http
